import React, { Component } from 'react'
import '../css/BisharatMain.css'
import AuthService from "../services/AuthService";
import Login from './Login';
import { MemberLinkBtnOrangeDark , MemberLinkBtnBordo , MemberLinkBtnPink, MemberLinkBtnDeepLilac , MemberLinkBtn , MemberLinkBtnBlue , MemberLinkBtnGold } from '../styles/Elements';

export default class AdminBoard extends Component {


  render() {
// const inactiveUserData = this.state.usersData;
const loggedInUser = AuthService.getCurrentUser();
const whatRole = AuthService.getUserRole();
    return (
      <div>
      { !loggedInUser || (whatRole === ('USER'))  ? 
      <div>
        <Login></Login>
      </div> :
      <>
       {(whatRole === ('ADMIN')) ?
       <div className="admin-board">
      

       <MemberLinkBtn to='/family-members/'>  Members - قائمة اعضاء العائلة   </MemberLinkBtn>
    
       <MemberLinkBtnOrangeDark to='/adminboard/users/'>  Users - قائمة المشتركين  </MemberLinkBtnOrangeDark>
     
       <MemberLinkBtnPink to='/adminboard/permissionRequestUsers/'>Permission Requests  صلاحيّات المشتركين </MemberLinkBtnPink>

       <MemberLinkBtnGold to='/adminboard/addmoderators'> Moderator - اضافة متحكم   </MemberLinkBtnGold>

       <MemberLinkBtnDeepLilac to='/family-notification/create'> Notification - اضافة اشعار   </MemberLinkBtnDeepLilac>
       <MemberLinkBtnBlue to='/family-activities/create'> Activity - اضافة فعاليّة   </MemberLinkBtnBlue>
       <MemberLinkBtnBordo to='/family-gallery/gallery-management'> Gallery Managment - التحكّم بالبوم الصور   </MemberLinkBtnBordo>
      </div> : 
       <div className="admin-board">
         <MemberLinkBtn to='/family-members/'>  Members - قائمة اعضاء العائلة   </MemberLinkBtn>
         <MemberLinkBtnDeepLilac to='/family-notification/create'> Notification - اضافة اشعار   </MemberLinkBtnDeepLilac>
         <MemberLinkBtnBlue to='/family-activities/create'> Activity - اضافة فعاليّة   </MemberLinkBtnBlue>
         <MemberLinkBtnBordo to='/family-gallery/gallery-management'> Gallery Managment - التحكّم بالبوم الصور    </MemberLinkBtnBordo>
      </div>
      }
      </>
      }
      </div>   
    )
    
}}